import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { LoginInstallChoiceModalComponent } from '../common/modals/login-install-choice-modal/login-install-choice-modal.component'
import { GeneralService } from '../services/general/general.service'
import { LogService } from '../services/log/log.service'
import { ModalService } from '../services/modal/modal.service'
import { UserService } from '../services/user/user.service'
import { LogEvent } from './../interfaces/log'

@Directive({
  selector: '[appLink]',
})
export class AppLinkDirective implements OnInit {
  constructor(
    private generalService: GeneralService,
    private userService: UserService,
    private logService: LogService,
    private translate: TranslateService,
    private modalService: ModalService
  ) {}

  @Input() disable = false
  @Input() appLinkPath: string | undefined
  @Input() buttonType: string | undefined
  @Input() isLoginNeeded = false
  @Output() onOpenAppSucceed = new EventEmitter<void>()

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    if (!this.disable) {
      // 클릭된 요소 정보
      const targetElement = event.target as HTMLElement
      // 부모 요소 정보 가져오기
      const parentElement = targetElement.parentElement

      const targetElemLogId = targetElement.getAttribute('log-id')
      const parentElemLogId = parentElement?.getAttribute('log-id')

      const logData = {
        logId: targetElemLogId ?? parentElemLogId,
        clickedPathname: location.pathname,
      }
      this.logService.eventLogging(LogEvent.APP_LINK_CLICKED, { ...logData })
      this.openApp(this.buttonType)
    }
  }

  ngOnInit(): void {}

  protected openApp(buttonType?: string): void {
    if (this.isLoginNeeded && !this.userService.isLoggedIn) {
      this.showAppInstallModal()
      return
    }
    this.onOpenAppSucceed.emit()
    this.generalService.deeplink.openApp(this.appLinkPath ?? '', buttonType)
  }

  private async showAppInstallModal(): Promise<void> {
    if (!this.userService.isLoggedIn) {
      const loginChoiceModal = await this.modalService.openBottomSheet(LoginInstallChoiceModalComponent, {
        logOnClickLogin: () => {},
        logOnClickInstall: () => {},
      })
      await loginChoiceModal.present()
    }
  }
}
